export function resolveApiBaseUrl(): string {
  const env = (window as unknown as { __env__?: Record<string, string | undefined> }).__env__;
  const envApiUrl = (env?.['apiUrl'] ?? env?.['COOASS_API_URL'] ?? '').trim();
  console.warn(`Using API URL from environment: ${envApiUrl}`);
  if (envApiUrl) {
    return `${envApiUrl.replace(/\/+$/, '')}/api/v1`;
  }
  return 'http://localhost:8000/api/v1';
}
